// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.server-connection-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99999;
  background-color: rgba(10, 10, 15, 0.85);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeInOverlay 0.25s ease-out forwards;
}

@keyframes fadeInOverlay {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.server-connection-card {
  width: 90%;
  max-width: 420px;
  background: rgba(22, 24, 32, 0.95);
  border: 1px solid rgba(239, 68, 68, 0.3);
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.6), 0 0 30px rgba(239, 68, 68, 0.15);
  border-radius: 16px;
  padding: 32px 28px;
  text-align: center;
  color: #f3f4f6;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.connection-icon-wrapper {
  width: 76px;
  height: 76px;
  border-radius: 50%;
  background: rgba(239, 68, 68, 0.12);
  border: 1px solid rgba(239, 68, 68, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
}

.connection-icon {
  color: #ef4444;
}

.pulse-red {
  animation: pulseRedIcon 1.8s infinite ease-in-out;
}

@keyframes pulseRedIcon {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.7;
  }
}

.connection-title {
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  color: #ffffff;
  letter-spacing: -0.3px;
}

.connection-status-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  width: 100%;
}

.connection-message {
  font-size: 14px;
  color: #9ca3af;
  margin: 0;
}

.attempt-badge {
  display: inline-block;
  background: rgba(239, 68, 68, 0.18);
  color: #fca5a5;
  border: 1px solid rgba(239, 68, 68, 0.35);
  padding: 2px 10px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 13px;
  margin-left: 4px;
}

.attempt-progress-dots {
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
}

.attempt-progress-dots .dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  transition: all 0.3s ease;
}

.attempt-progress-dots .dot.active {
  background: #ef4444;
  box-shadow: 0 0 10px rgba(239, 68, 68, 0.8);
  transform: scale(1.3);
}

.attempt-progress-dots .dot.completed {
  background: #f87171;
}

.spinner-wrapper {
  margin-top: 4px;
}

.spinner {
  color: #9ca3af;
  animation: spinCw 1.2s linear infinite;
}

@keyframes spinCw {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.connection-failed-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  width: 100%;
  margin-top: 4px;
}

.failed-text {
  font-size: 13px;
  color: #9ca3af;
  line-height: 1.5;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

.warning-icon {
  color: #f59e0b;
  flex-shrink: 0;
}

.retry-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 12px 20px;
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  color: #ffffff;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(220, 38, 38, 0.4);
  transition: all 0.2s ease;
}

.retry-button:hover {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  box-shadow: 0 6px 20px rgba(239, 68, 68, 0.5);
  transform: translateY(-1px);
}

.retry-button:active {
  transform: translateY(0);
}
`, "",{"version":3,"sources":["webpack://./src/components/ServerConnectionOverlay/ServerConnectionOverlay.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,cAAc;EACd,wCAAwC;EACxC,2BAA2B;EAC3B,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gDAAgD;AAClD;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,kCAAkC;EAClC,wCAAwC;EACxC,4EAA4E;EAC5E,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,YAAY;EACd;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,cAAc;EACd,yCAAyC;EACzC,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,6DAA6D;EAC7D,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".server-connection-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 99999;\n  background-color: rgba(10, 10, 15, 0.85);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: fadeInOverlay 0.25s ease-out forwards;\n}\n\n@keyframes fadeInOverlay {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.server-connection-card {\n  width: 90%;\n  max-width: 420px;\n  background: rgba(22, 24, 32, 0.95);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.6), 0 0 30px rgba(239, 68, 68, 0.15);\n  border-radius: 16px;\n  padding: 32px 28px;\n  text-align: center;\n  color: #f3f4f6;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n}\n\n.connection-icon-wrapper {\n  width: 76px;\n  height: 76px;\n  border-radius: 50%;\n  background: rgba(239, 68, 68, 0.12);\n  border: 1px solid rgba(239, 68, 68, 0.25);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 4px;\n}\n\n.connection-icon {\n  color: #ef4444;\n}\n\n.pulse-red {\n  animation: pulseRedIcon 1.8s infinite ease-in-out;\n}\n\n@keyframes pulseRedIcon {\n  0%, 100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.1);\n    opacity: 0.7;\n  }\n}\n\n.connection-title {\n  font-size: 20px;\n  font-weight: 700;\n  margin: 0;\n  color: #ffffff;\n  letter-spacing: -0.3px;\n}\n\n.connection-status-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 14px;\n  width: 100%;\n}\n\n.connection-message {\n  font-size: 14px;\n  color: #9ca3af;\n  margin: 0;\n}\n\n.attempt-badge {\n  display: inline-block;\n  background: rgba(239, 68, 68, 0.18);\n  color: #fca5a5;\n  border: 1px solid rgba(239, 68, 68, 0.35);\n  padding: 2px 10px;\n  border-radius: 20px;\n  font-weight: 600;\n  font-size: 13px;\n  margin-left: 4px;\n}\n\n.attempt-progress-dots {\n  display: flex;\n  gap: 8px;\n  justify-content: center;\n  align-items: center;\n}\n\n.attempt-progress-dots .dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.15);\n  transition: all 0.3s ease;\n}\n\n.attempt-progress-dots .dot.active {\n  background: #ef4444;\n  box-shadow: 0 0 10px rgba(239, 68, 68, 0.8);\n  transform: scale(1.3);\n}\n\n.attempt-progress-dots .dot.completed {\n  background: #f87171;\n}\n\n.spinner-wrapper {\n  margin-top: 4px;\n}\n\n.spinner {\n  color: #9ca3af;\n  animation: spinCw 1.2s linear infinite;\n}\n\n@keyframes spinCw {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.connection-failed-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 18px;\n  width: 100%;\n  margin-top: 4px;\n}\n\n.failed-text {\n  font-size: 13px;\n  color: #9ca3af;\n  line-height: 1.5;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.warning-icon {\n  color: #f59e0b;\n  flex-shrink: 0;\n}\n\n.retry-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  padding: 12px 20px;\n  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);\n  color: #ffffff;\n  border: none;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  box-shadow: 0 4px 14px rgba(220, 38, 38, 0.4);\n  transition: all 0.2s ease;\n}\n\n.retry-button:hover {\n  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);\n  box-shadow: 0 6px 20px rgba(239, 68, 68, 0.5);\n  transform: translateY(-1px);\n}\n\n.retry-button:active {\n  transform: translateY(0);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
